import { useEffect, useState } from "react";
import CheckboxFlecha from "../../../../assets/images/generico/CheckboxFlecha";
import CheckboxFlechaMenos from "../../../../assets/images/generico/CheckboxFlechaMenos";
import "./ItemCheckBoxGroup.css";

const ItemCheckBoxGroup = ({ type, onChange, checked, id, noDropdown }) => {
  const [state, setState] = useState(false);

  // Hace que se setee el checked
  useEffect(() => {
    if (typeof checked === "boolean") {
      setState(checked);
    }
  }, [checked]);

  // Es el handleClick
  const handleClick = () => {
    if (typeof checked === "boolean") {
      // setState(checked)
      onChange({
        target: {
          id,
          checked: !state,
        },
      });
    } else {
      onChange({
        target: {
          id,
          checked: !state,
        },
      });
      setState(!state);
    }
  };

  return (
    <div
      className={`ptur-ItemCheckBoxGroup-container ${
        noDropdown ? "bgc-white" : "bgc-grey90"
      }`}
      onClick={handleClick}
    >
      {!state && type !== "MENOS" ? (
        ""
      ) : !state ? (
        <CheckboxFlechaMenos color="var(--color-white)" />
      ) : (
        <CheckboxFlecha color="var(--color-white)" />
      )}
    </div>
  );
};

export default ItemCheckBoxGroup;
